let baseUrl = process.env.REACT_APP_GFS_BASE_URL

export default async function FormattedWeather(lat, lng) {
  let url = `${baseUrl}/interpolate?lat=${lat}&lon=${lng}`;

  let result = await fetch(url);

  if (!result.ok) {
    throw new Error(`HTTP error! status: ${result.status}`);
  }

  return await result.json();

}
